import { render } from "./ScrollReveal.vue?vue&type=template&id=62150e80&scoped=true"
import script from "./ScrollReveal.vue?vue&type=script&lang=js"
export * from "./ScrollReveal.vue?vue&type=script&lang=js"

import "./ScrollReveal.vue?vue&type=style&index=0&id=62150e80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62150e80"]])

export default __exports__